import React from "react";

export function MessengerActions() {
	return (
		'Messenger Actions'
	)
}
